// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"core":"63ce464f2cab7bb46aca","pg-service-offers-common":"ea757eb6b84060a59f9e","CartSidebarOffersTab":"0459b2f39f6be725d941","CartSidebarCartOffers":"8063f3f2b22e6d28372a","CartSidebarOffersCodeModule":"fd8ec4ab3f6bb5c03778"}[chunkId] + ".bundle.js";
};